// extracted by mini-css-extract-plugin
module.exports = {"root":"MultiRowSelect_root__34-A1"};